import React, { useMemo } from "react";
import ProductCard from "./ProductCard";
import { ProductCategoryType } from "../../../../types";
import ProductCard2 from "./ProductCard2";

export interface ProductListProps {
    productCategory: ProductCategoryType;
}

const ProductList = ({ productCategory }: ProductListProps) => {

    const sorted = useMemo(() => {
        return (productCategory?.products || []).sort((a, b) => (a.sort || 0) > (b.sort || 0) ? 1 : -1);
    }, [productCategory?.products]);

    const template = useMemo(() => {
        if (productCategory?.name === "Book Shop") {
            return "template2";
        }
        return "default";
    }, [productCategory?.name]);

    return (
        <div className="flex flex-wrap -mx-2">
            {sorted.map(prd => (
                <React.Fragment key={prd.id}>
                    {prd?.id && (
                        <div key={prd.id} className="
                                w-full px-2 mb-2
                                md:w-1/2
                                xl:w-1/4 md:mb-4
                            ">
                            {template === "default" && (
                                <ProductCard product={prd} key={prd.id} />
                            )}
                            {template === "template2" && (
                                <ProductCard2 product={prd} key={prd.id} />
                            )}

                        </div>
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default ProductList;
